'use client';

import { t } from 'mobx-state-tree';

import { PropertyType } from '../propertyType';

import { PropertyBase } from './propertyBase';

import type { Instance } from 'mobx-state-tree';

/** Model for string property */
export const StringProperty = t.compose('StringProperty', PropertyBase,
  t.model({
    type: t.literal(PropertyType.String),
    value: t.optional(t.string, ''),
    defaultValue: t.optional(t.string, ''),
    placeholder: t.maybe(t.string),
    multiline: t.optional(t.boolean, false)
  })
).actions(self => ({
  setValue(value: string, fromPanel = true, initial = false) {
    if (value === self.value) return;
    self.value = value;
    self.notifyValueChange(self.path, value, { fromPanel, initial, property: self as Instance<typeof StringProperty> });
  },
  setDefaultValue(value: string) {
    self.defaultValue = value;
  },
  setPlaceholder(placeholder?: string) {
    self.placeholder = placeholder;
  }
}));
